export default {
  brand: '广州坚谷粒网络科技有限公司',
  'nav.home': '首页',
  'nav.services': '服务项目',
  'nav.cases': '成功案例',
  'nav.testimonials': '客户评价',
  'nav.process': '合作流程',
  'nav.contact': '联系我们',
  'cta.freeConsult': '免费咨询',
  'hero.title1': '专业软件开发',
  'hero.title2': '助力企业数字化转型',
  'hero.desc1': '提供网站、小程序、APP开发服务，以及专业的PHP到Go语言迁移咨询',
  'hero.desc2': '让技术成为您业务增长的强大引擎',
  'hero.learn': '了解服务',
  'lang.zh': '中文',
  'lang.en': 'English',
  'services.title': '专业服务项目',
  'services.intro': '我们提供全方位的软件开发服务，从前端到后端，从设计到部署，为您的业务提供完整的技术解决方案',
  'services.techTitle': '技术优势',
  'services.items.web.title': '网站开发',
  'services.items.web.desc': '响应式企业官网、电商平台、管理系统等各类网站开发，采用最新技术栈确保性能与用户体验',
  'services.items.web.features': ['响应式设计', 'SEO优化', '高性能架构', '安全防护'],
  'services.items.mini.title': '小程序开发',
  'services.items.mini.desc': '微信小程序、支付宝小程序等多平台小程序开发，助力企业快速进入移动互联网生态',
  'services.items.mini.features': ['多平台支持', '原生体验', '快速部署', '数据分析'],
  'services.items.app.title': 'APP开发',
  'services.items.app.desc': 'iOS和Android原生应用开发，提供完整的移动解决方案，从设计到上架全程服务',
  'services.items.app.features': ['原生开发', '跨平台兼容', '应用商店上架', '后期维护'],
  'services.items.migration.title': 'PHP到Go迁移',
  'services.items.migration.desc': '专业的技术咨询服务，帮助企业从PHP平滑迁移到Go语言，提升系统性能和可维护性',
  'services.items.migration.features': ['架构重构', '性能优化', '平滑迁移', '技术培训'],
  'cases.title': '成功案例',
  'cases.intro': '我们已为众多企业提供优质的软件开发服务，以下是部分成功案例展示',
  'cases.categories.all': '全部案例',
  'cases.categories.web': '网站开发',
  'cases.categories.mini': '小程序',
  'cases.categories.app': 'APP开发',
  'cases.categories.blockchain': '区块链',
  'cases.categories.migration': '技术迁移',
  'cases.categories.ai': 'AI系统',
  'cases.items.1.title': 'AI智能后台管理系统',
  'cases.items.1.desc': '集成AI对话功能的企业后台管理系统，通过自然语言对话生成各类数据报表，让数据分析变得简单直观。',
  'cases.items.2.title': '电商平台小程序',
  'cases.items.2.desc': '功能完善的电商小程序，支持商品展示、购物车、支付、订单管理等完整购物流程。',
  'cases.items.3.title': '企业官网重构',
  'cases.items.3.desc': '响应式企业官网，采用现代化设计理念，优化用户体验和SEO表现。',
  'cases.items.4.title': 'NFT数字藏品平台',
  'cases.items.4.desc': '完整的NFT数字藏品交易平台，支持铸造、展示、交易、拍卖等功能，打造数字艺术品生态。',
  'cases.items.5.title': '移动办公APP',
  'cases.items.5.desc': '企业移动办公解决方案，集成考勤、审批、通讯、文档管理等功能。',
  'cases.items.6.title': 'DeFi流动性挖矿平台',
  'cases.items.6.desc': '去中心化金融平台，提供流动性挖矿、质押收益、代币交换等DeFi服务。',
  'cases.items.7.title': '在线教育平台',
  'cases.items.7.desc': '综合性在线教育平台，支持直播授课、录播回放、作业提交、成绩管理等功能。',
  'cases.items.8.title': '区块链供应链溯源',
  'cases.items.8.desc': '基于区块链的供应链管理系统，实现产品全流程可追溯和防伪验证。',
  'cases.items.9.title': '智能客服小程序',
  'cases.items.9.desc': '集成AI智能客服的小程序，支持自动回复、人工客服、工单管理等功能。',
  'cases.items.10.title': '智能合约审计平台',
  'cases.items.10.desc': '专业的智能合约安全审计平台，提供代码安全检测、漏洞分析和修复建议。',
  'cases.items.11.title': 'PHP到Go系统迁移',
  'cases.items.11.desc': '大型电商平台从PHP架构迁移到Go语言，性能提升300%，并发处理能力大幅增强。',
  'cases.items.12.title': '数据分析可视化平台',
  'cases.items.12.desc': '企业级数据分析平台，通过AI对话生成定制化报表，支持多维度数据挖掘和可视化展示。',
  'cases.stat.users': '用户数',
  'cases.stat.rating': '评分',
  'cases.stat.duration': '开发周期',
  'testimonials.title': '客户评价',
  'testimonials.intro': '客户的认可是我们前进的动力，以下是部分客户的真实评价',
  'stats.projects': '成功项目',
  'stats.clients': '合作客户',
  'stats.satisfaction': '客户满意度',
  'stats.support': '技术支持',
  'process.title': '合作流程',
  'process.intro': '我们采用标准化的项目管理流程，确保每个项目都能按时按质完成',
  'process.items.1.title': '需求沟通',
  'process.items.1.desc': '深入了解您的业务需求，分析项目可行性，制定初步解决方案',
  'process.items.1.details': ['业务需求分析', '技术可行性评估', '项目范围确定', '初步方案设计'],
  'process.items.2.title': '方案设计',
  'process.items.2.desc': '制定详细的技术方案和项目计划，确保项目顺利进行',
  'process.items.2.details': ['技术架构设计', 'UI/UX设计', '开发计划制定', '风险评估分析'],
  'process.items.3.title': '开发实施',
  'process.items.3.desc': '按照敏捷开发流程，分阶段完成项目开发，定期汇报进度',
  'process.items.3.details': ['敏捷开发模式', '代码质量保证', '定期进度汇报', '阶段性交付'],
  'process.items.4.title': '测试部署',
  'process.items.4.desc': '全面测试确保质量，协助部署上线，提供使用培训',
  'process.items.4.details': ['功能测试', '性能测试', '安全测试', '部署上线'],
  'process.items.5.title': '维护支持',
  'process.items.5.desc': '提供持续的技术支持和维护服务，确保系统稳定运行',
  'process.items.5.details': ['技术支持', '系统维护', '功能升级', '问题解决'],
  'contact.title': '联系我们',
  'contact.subtitle': '准备开始您的项目？我们的专业团队随时为您提供技术咨询和解决方案',
  'contact.methodsTitle': '联系方式',
  'contact.phoneTitle': '电话咨询',
  'contact.mailTitle': '邮箱联系',
  'contact.addressTitle': '公司地址',
  'contact.hours': '工作日 9:00-18:00',
  'contact.reply': '24小时内回复',
  'contact.formTitle': '项目咨询',
  'contact.form.name': '姓名 *',
  'contact.form.namePlaceholder': '请输入您的姓名',
  'contact.form.company': '公司名称',
  'contact.form.companyPlaceholder': '请输入公司名称',
  'contact.form.phone': '联系电话 *',
  'contact.form.phonePlaceholder': '请输入手机号码',
  'contact.form.email': '邮箱地址',
  'contact.form.emailPlaceholder': '请输入邮箱地址',
  'contact.form.service': '服务类型 *',
  'contact.form.servicePlaceholder': '请选择服务类型',
  'contact.form.blockchain': '区块链开发',
  'contact.form.consulting': '技术咨询',
  'contact.form.other': '其他',
  'contact.form.budget': '预算范围',
  'contact.form.budgetPlaceholder': '请选择预算范围',
  'contact.form.budgetRanges': ['5万以下', '5-10万', '10-20万', '20-50万', '50万以上', '面议'],
  'contact.form.message': '项目描述 *',
  'contact.form.messagePlaceholder': '请详细描述您的项目需求，包括功能要求、技术要求等（限500字符）',
  'contact.form.submit': '提交咨询',
  'contact.form.submitting': '提交中...',
  'footer.quick': '快速导航',
  'footer.contact': '联系方式',
  'footer.intro1': '专业的软件开发公司，致力于为客户提供高质量的网站、小程序、APP开发服务。',
  'footer.intro2': '我们拥有经验丰富的技术团队，为您的数字化转型保驾护航。'
}
